import { australianState, countriesList } from "@fla/common";
import {
  AutocompleteGooglePlaces,
  ConsentOrdersUserDetailsSchema,
  DatePicker,
  InitialDetails,
  RadioSelect,
  Select,
  TextInput,
  UserIcon,
  useAddress
} from "@fla/components";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

interface IProps {
  formId: string;
  store: InitialDetails;
  onSubmit: (values: InitialDetails) => void;
}

export default function UserDetails({ onSubmit, formId, store }: IProps) {
  const { handleSubmit, control, watch, setValue, formState:{errors} } = useForm({
    mode: "all",
    defaultValues: store,
    resolver: yupResolver(ConsentOrdersUserDetailsSchema)
  });
  const { handleNewLocation } = useAddress();
  const onSelectAddress = async (val: any) => {
    console.log("val", val);
    if (val?.__isNew__) {
      setValue("user.line1_address", val.value);
      return;
    }

    const address = await handleNewLocation(val.label);

    if (address?.locality) {
      setValue("user.suburb", address.locality);
    }
    // if (address?.country) {
    //   const country = countriesList.find(v => v.name.toLowerCase() === address.country.toLowerCase());
    //   setValue("user.country", country);
    // }
    if (address?.postalCode) {
      setValue("user.postcode", address.postalCode);
    }
    if (address?.state && Array.isArray(australianState)) {
      const state = australianState.find(v => v.label?.toLowerCase() === address.state?.toLowerCase())?.value;
      if (state) setValue("user.state", state);
    }
    if (address?.streetAddress) {
      setValue("user.line1_address", address.streetAddress);
    }
  };
console.log("errors", errors)
  return (
    <form id={formId} className="space-y-5" onSubmit={handleSubmit(onSubmit)}>
      <div className="mb-8 pb-8 border-b">
        <UserIcon classes="w-14 h-14 mx-auto mb-5" />
        <h3 className="text-center">Your Details</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4">
        <TextInput
          title="First Name"
          control={control}
          name="user.first_name"
          id="user.first_name"
          placeholder="First Name"
          wrapClasses="col-span-1"
        />
        <TextInput
          title="Last Name"
          control={control}
          name="user.last_name"
          id="user.last_name"
          placeholder="Last Name"
          wrapClasses="col-span-1"
        />
      </div>

      <RadioSelect title="Gender" control={control} name="user.gender" id="user.gender" options={["male", "female"]} />
      <TextInput
        title="Occupation"
        control={control}
        name="user.job"
        id="user.job"
        placeholder=""
        wrapClasses="col-span-1"
      />

      <AutocompleteGooglePlaces
        title={
          <div className="space-y-2">
            <p className="font-bold text-sm">Residential or Mailing Address</p>
            <p className="text-gray-500 font-semibold uppercase text-xs pb-4">Street Address</p>
          </div>
        }
        name="user.line1_address"
        control={control}
        onSelectAddress={onSelectAddress}
      />

      <TextInput
        title="Suburb"
        titleClasses="text-gray-500 font-semibold uppercase text-xs"
        control={control}
        name="user.suburb"
        id="user.suburb"
        placeholder="Suburb"
        wrapClasses="col-span-1"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4">
        <Select
          title="State"
          titleClasses="text-gray-500 font-semibold uppercase text-xs"
          control={control}
          name="user.state"
          id="user.state"
          placeholder="Select State"
          className="col-span-1"
          options={australianState}
        />
        <TextInput
          title="Postcode"
          titleClasses="text-gray-500 font-semibold uppercase text-xs"
          control={control}
          name="user.postcode"
          id="user.postcode"
          placeholder="PostCode"
          wrapClasses="col-span-1"
        />
      </div>
      {watch("user.state") === "overseas" ? (
        <>
          <TextInput
            title="Overseas State"
            titleClasses="text-gray-500 font-semibold uppercase text-xs"
            control={control}
            name="user.overseas_state"
            id="user.overseas_state"
            placeholder="eg: state"
            wrapClasses="col-span-1"
          />

          <Select
            title="Overseas Country"
            titleClasses="text-gray-500 font-semibold uppercase text-xs"
            control={control}
            name="user.overseas_country"
            id="user.overseas_country"
            placeholder="Select Country"
            options={countriesList.map(country => ({
              label: country.name,
              value: country.name
            }))}
          />
        </>
      ) : null}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <DatePicker title="Date Of Birth" control={control} name="user.dob" version="v2" />

        <Select
          title="Place Of Birth"
          control={control}
          name="user.birth_country"
          id="user.birth_country"
          placeholder="Select Birth Place"
          options={countriesList.map(country => ({
            label: country.name,
            value: country.name
          }))}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <TextInput
          title="Mobile Number"
          control={control}
          name="user.mobile"
          id="user.mobile"
          placeholder="Mobile number"
          wrapClasses="col-span-1"
        />
        <TextInput
          type="email"
          title="Email Address"
          control={control}
          name="user.email"
          id="user.email"
          placeholder="eg: john@doe.ex"
          wrapClasses="col-span-1"
        />
      </div>
    </form>
  );
}
